(() => {
  'use strict';
  const key = 'fgs-shopping-context-v1';
  const restoreKey = 'fgs-shopping-restore-v1';
  const isShopPath = path => /^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/(products|collections)\//.test(path);
  const read = () => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const safeUrl = value => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && isShopPath(url.pathname) ? url : null; } catch (_) { return null; }
  };
  const save = () => {
    if (!isShopPath(location.pathname)) return;
    const url = new URL(location.pathname, location.origin);
    const variant = new URLSearchParams(location.search).get('variant');
    if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
    url.hash = location.hash;
    const openFamilies = Array.from(document.querySelectorAll('.fgs-family details[open]')).map(el => el.closest('.fgs-family').id);
    try { sessionStorage.setItem(key, JSON.stringify({url: url.pathname + url.search + url.hash, scrollY: scrollY, openFamilies})); } catch (_) { /* Storage can be unavailable. The standard links still work. */ }
  };
  const updateLinks = () => {
    const context = read();
    const url = context && safeUrl(context.url);
    if (!url) return;
    document.querySelectorAll('[data-fgs-continue-shopping], cart-items .title-wrapper-with-link > a.underlined-link, cart-items .cart__warnings > a.button').forEach(link => { link.dataset.fgsContinueShopping = ''; link.href = url.pathname + url.search + url.hash; });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-fgs-continue-shopping]');
    if (!link) return;
    updateLinks();
    if (safeUrl(link.href)) { try { sessionStorage.setItem(restoreKey, '1'); } catch (_) {} }
  });
  window.addEventListener('pagehide', save);
  window.addEventListener('pageshow', () => {
    updateLinks();
    const context = read();
    const url = context && safeUrl(context.url);
    let restore = false;
    try { restore = sessionStorage.getItem(restoreKey) === '1'; sessionStorage.removeItem(restoreKey); } catch (_) {}
    if (!restore || !url || url.pathname !== location.pathname) return;
    (context.openFamilies || []).forEach(id => { const family = document.getElementById(id); const details = family && family.querySelector('details'); if (details) details.open = true; });
    const y = Number.isFinite(context.scrollY) ? Math.max(0, context.scrollY) : 0;
    requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, y)));
  });
  updateLinks();
  const subscribeDetails = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      const source = data.html && data.html.querySelector('[data-fgs-selected-details]');
      const destination = productInfo && productInfo.querySelector('[data-fgs-selected-details]');
      if (!source || !destination) return;
      const open = Array.from(destination.querySelectorAll('details')).map(detail => detail.open);
      destination.innerHTML = source.innerHTML;
      destination.querySelectorAll('details').forEach((detail, index) => { detail.open = Boolean(open[index]); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', subscribeDetails, { once: true });
  else subscribeDetails();
  // Filter on both the server and client so cached/open pages stop promoting an event at its exact end time.
  const updateEvents = () => {
    document.querySelectorAll('[data-fgs-event-list]').forEach(list => {
      const cards = Array.from(list.querySelectorAll('[data-fgs-upcoming-event]'));
      cards.forEach(card => { const end = Date.parse(card.dataset.endAt || ''); card.hidden = !Number.isFinite(end) || Date.now() >= end; });
      const empty = list.querySelector('[data-fgs-events-empty]');
      if (empty) empty.hidden = cards.some(card => !card.hidden);
      if (list.classList.contains('fgs-event-list--compact')) {
        let shown = false;
        cards.forEach(card => { if (!card.hidden) { card.hidden = shown; shown = true; } });
      }
    });
  };
  updateEvents();
  window.setInterval(updateEvents, 30000);
  document.addEventListener('visibilitychange', updateEvents);
})();
